
<template>
  <main>
    <nav-bar type='center'></nav-bar>
    <div class="content">
      <div class="centerboard">
        <transition name="fade" mode="out-in">
          <router-view name="dashboard"></router-view>
        </transition>
      </div>
    </div>
    <icons></icons>
  </main>
</template>

<script>
import NavBar from 'NavBar/Main'
import SideBar from 'SideBar/Main'
import Icons from 'Icons'

export default {
  name: 'CenterContent',
  components: {
    NavBar,
    SideBar,
    Icons
  }
}
</script>

<style lang="stylus" scoped>
@import '~styl/mixins'
svg-icons()
main
  height: 100%
.content
  width: 12rem
  min-height: 100%
  margin: -0.6rem auto 0
  padding-top: .6rem
  position: absolute;
  left: 0;
  right: 0;
  top: 0.6rem;
  bottom: 0;
.centerboard
  // 与 aside 相加为至少 12rem
  // box-shadow: 0 -100px 4px 0 rgba(0,0,0,.12), 0 0 6px 0 rgba(0,0,0,.04);
  margin:0 auto
  z-index: auto
</style>
<style lang="stylus">
  @import '~styl/mixins'
  svg-icons()
  main
    height: 100%
  .content
    position absolute
    left 0
    right 0
    top .6rem
    bottom 0
    &.show-guide
      overflow hidden
  .dashboard
    height 100%
    min-width 13.5rem
    padding-left 2.1rem
    border-left 1px #e4e4e4 solid
    z-index auto
    overflow-y auto
  // transition padding-left .3s ease-in-out
  .clearfix
    zoom: 1
    &:after
      content: " "
      display: block
      clear: both
      height: 0
  .page .el-tabs__active-bar,.page .el-table::after,.page .el-table::before
    z-index:0
  .copyUrl
    position absolute;
    top 0;
    opacity 0;
    z-index 0;
</style>



// WEBPACK FOOTER //
// app/components/CenterContent.vue